import { useState, useEffect } from 'react'

const useDeviceDetection = () => {
  const [device, setDevice] = useState({ isMobile: false, isTablet: false, isDesktop: false })

  useEffect(() => {
    const handleDeviceDetection = () => {
      const userAgent = navigator.userAgent.toLowerCase()
      const isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent)
      const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent)

      if (isMobile) {
        setDevice({ isMobile: true, isTablet: false, isDesktop: false })
      } else if (isTablet) {
        setDevice({ isMobile: false, isTablet: true, isDesktop: false })
      } else {
        setDevice({ isMobile: false, isTablet: false, isDesktop: true })
      }
    }

    handleDeviceDetection()
    window.addEventListener('resize', handleDeviceDetection)

    return () => {
      window.removeEventListener('resize', handleDeviceDetection)
    }
  }, [])

  return device
}

export default useDeviceDetection
